import { GetStaticPropsContext, InferGetStaticPropsType } from 'next';
import { getB12Page } from 'repos/b12Page';
import { getAllMenuPage } from 'repos/menu';

import FeaturesBlock from 'components/B12Page/FeaturesBlock';
import Hero from 'components/B12Page/Hero';
import IntegrationsBlock from 'components/B12Page/IntegrationsBlock';
import B12VideoBlock from 'components/B12VideoBlock';
import FAQBlock from 'components/FAQBlock';
import HighlightsBlock from 'components/HighlightsBlock';
import QuoteCTABlock from 'components/QuoteCTABlock';
import TestimonialsBlock from 'components/TestimonialsBlock';
import Layout from 'components/layout';
import SEO from 'components/seo';

export default function B12Page({
  b12Page,
  menuParams,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  const {
    heroTitle,
    heroSubtitle,
    videoUrl,
    howItWorksTitle,
    howItWorkSubtitle,
    highlights,
    faqTitle,
    questions,
    ctaText,
    ctaButtonText1,
    ctaButtonText2,
    testimonialTitle,
    testimonials,
    heroButtonLink,
    heroButtonTitle,
    featureSectionTitle,
    featureSectionSubtitle,
    features,
    integrationSubtitle,
    integrationTitle,
    integrations,
  } = b12Page.fields;

  return (
    <Layout menuParams={menuParams}>
      <SEO title="B12" />
      <Hero
        title={heroTitle}
        subtitle={heroSubtitle}
        buttonText={heroButtonTitle}
        buttonLink={heroButtonLink}
      />
      <B12VideoBlock
        title={howItWorksTitle}
        subtitle={howItWorkSubtitle}
        videoUrl={videoUrl}
      />
      <HighlightsBlock
        highlights={highlights}
        imageOverride={{
          width: 450,
          height: 352,
        }}
      />
      <IntegrationsBlock
        title={integrationTitle}
        subtitle={integrationSubtitle}
        integrations={integrations}
      />
      <TestimonialsBlock title={testimonialTitle} testimonials={testimonials} />
      <FeaturesBlock
        features={features}
        title={featureSectionTitle}
        subtitle={featureSectionSubtitle}
      />
      <FAQBlock title={faqTitle} questions={questions} />

      <QuoteCTABlock
        text={ctaText}
        buttonText1={ctaButtonText1}
        buttonText2={ctaButtonText2}
      />
    </Layout>
  );
}

export async function getStaticProps({
  locale,
  preview,
}: GetStaticPropsContext) {
  const b12Page = await getB12Page({ locale, preview });
  const menuParams = await getAllMenuPage({ locale });

  return {
    props: { b12Page, menuParams },
  };
}
